// Market clock helpers shared by the landing page and the portfolio note.

export function isUSMarketHoliday(date) {
  const m = date.getMonth(), d = date.getDate(), dow = date.getDay();
  if (m === 0 && d === 1 && dow > 0 && dow < 6) return true;            // New Year's Day
  if (m === 0 && d === 2 && dow === 1) return true;
  if (m === 11 && d === 31 && dow === 5) return true;
  if (m === 0 && dow === 1 && d >= 15 && d <= 21) return true;          // MLK Day
  if (m === 1 && dow === 1 && d >= 15 && d <= 21) return true;          // Presidents' Day
  if (m === 4 && dow === 1 && d >= 25) return true;                     // Memorial Day
  if (m === 5 && d === 19 && dow > 0 && dow < 6) return true;           // Juneteenth
  if (m === 5 && d === 20 && dow === 1) return true;
  if (m === 5 && d === 18 && dow === 5) return true;
  if (m === 6 && d === 4 && dow > 0 && dow < 6) return true;            // Independence Day
  if (m === 6 && d === 5 && dow === 1) return true;
  if (m === 6 && d === 3 && dow === 5) return true;
  if (m === 8 && dow === 1 && d <= 7) return true;                      // Labor Day
  if (m === 10 && dow === 4 && d >= 22 && d <= 28) return true;         // Thanksgiving
  if (m === 11 && d === 25 && dow > 0 && dow < 6) return true;          // Christmas
  if (m === 11 && d === 26 && dow === 1) return true;
  if (m === 11 && d === 24 && dow === 5) return true;
  return false;
}

// 'open' | 'pre-market' | 'after-hours' | 'closed', in New York time.
export function usMarketStatus(now = new Date()) {
  const et = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
  const day = et.getDay();
  if (day === 0 || day === 6 || isUSMarketHoliday(et)) return 'closed';
  const minutes = et.getHours() * 60 + et.getMinutes();
  if (minutes >= 570 && minutes < 960) return 'open';
  if (minutes >= 960 && minutes < 1200) return 'after-hours';
  if (minutes >= 240 && minutes < 570) return 'pre-market';
  return 'closed';
}

export const MARKET_STATUS_LABEL = {
  open: 'US markets open',
  'pre-market': 'US pre-market',
  'after-hours': 'US after hours',
  closed: 'US markets closed',
};

export function timeAgo(timestamp) {
  if (!timestamp) return '';
  const seconds = Math.floor(Date.now() / 1000 - timestamp);
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  return `${Math.floor(seconds / 86400)}d ago`;
}

export function formatEarningsDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(`${dateStr}T00:00:00`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diffDays = Math.ceil((date - today) / 86400000);
  if (diffDays === 0) return 'Today';
  if (diffDays === 1) return 'Tomorrow';
  return date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
}

// "Friday 11 September 2026"
export function formatNoteDate(date = new Date()) {
  return date.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).replace(',', '');
}

// "14:32 ET"
export function formatEtClock(date = new Date()) {
  return `${date.toLocaleTimeString('en-US', { timeZone: 'America/New_York', hour: '2-digit', minute: '2-digit', hour12: false })} ET`;
}
